import { render } from "./PersonIcon.vue?vue&type=template&id=6417d1ef"
const script = {}
script.render = render

export default script